/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Avatar_SettingsInputs */

const en_dashboard_avatar_settings = /** @type {(inputs: Dashboard_Avatar_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings`)
};

const es_dashboard_avatar_settings = /** @type {(inputs: Dashboard_Avatar_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustes`)
};

/**
* | output |
* | --- |
* | "Settings" |
*
* @param {Dashboard_Avatar_SettingsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dashboard_avatar_settings = /** @type {((inputs?: Dashboard_Avatar_SettingsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Avatar_SettingsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_avatar_settings(inputs)
	return es_dashboard_avatar_settings(inputs)
});